import { LiveDealerGame } from "@/live-dealer/models/live-dealer-game";
import { LiveDealerTable } from "@sazka/websocket/notifications/websocket/models/live-dealer-tables";
import { ref } from "vue";

const cards = ref<LiveDealerGame[]>([]);

export function useLiveDealerCards() {
    function updateCards(tables: LiveDealerTable[]) {
        tables.forEach((tableUpdate) => {
            const matchingCard = cards.value.find((card) => card.tableId === tableUpdate.tableId);

            if (matchingCard) {
                matchingCard.liveData.dealerName = tableUpdate.dealerName ?? null;
                matchingCard.liveData.dealerImage = tableUpdate.dealerImage ?? null;
                matchingCard.liveData.isCurrentlyAvailable = tableUpdate.isCurrentlyAvailable ?? null;
                matchingCard.liveData.playersCount = tableUpdate.playersCount ?? null;
                matchingCard.liveData.tableResults = tableUpdate.tableResults ?? null;

                if (matchingCard.happyHour) {
                    matchingCard.happyHour.isActive = tableUpdate.isHappyHour ?? null;
                }
            }
        });
    }

    return { cards, updateCards };
}
